import img1 from '../assets/img1.png'
import img2 from '../assets/img2.png'
import img3 from '../assets/img3.png'
import img4 from '../assets/img4.png'
import img5 from '../assets/img5.png'
import img6 from '../assets/img6.png'
import img7 from '../assets/img7.png'
import img8 from '../assets/img8.png'
import img9 from '../assets/img9.png'
import img10 from '../assets/img10.png'
import img11 from '../assets/img11.png'
import img12 from '../assets/img12.png'
import img13 from '../assets/img13.png'
import img14 from '../assets/img14.png'

export const SliderProducts = [{
    name: 'SKIN',
    detail: 'Super Skin Care',
    price: '425',
    img: img1
},
{
    name: 'SKIN',
    detail: 'Super Skin Care',
    price: '830',
    img: img2
},
{
    name: 'NATURE',
    detail: 'Super Skin Care',
    price: '725',
    img: img3
},
{
    name: 'Foundation',
    detail: 'Super Skin Care',
    price: '825',
    img: img4,
    type: 'foundation',
},
{
    name: 'CONDITIONER',
    detail: 'Super Skin Care',
    price: '579',
    img: img5,
    type: 'conditioner',
},
{
    name: 'NATURE',
    detail: 'Super Skin Care',
    price: '525',
    img: img6,
    type: 'skin care',
},
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '930',
    img: img7,
    type: 'conditioners'
}
,
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '430',
    img: img8,
    type: 'conditioners'
},
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '830',
    img: img9,
    type: 'conditioner'
},
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '530',
    img: img10,
    type: 'conditioner'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '712',
    img: img11,
    type: 'foundation'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '912',
    img: img12,
    type: 'foundation'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '512',
    img: img13,
    type: 'foundation'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '612',
    img: img14,
    type: 'foundation'
}
]
export const ProductsData = [{
    name: 'SKIN',
    detail: 'Super Skin Care',
    price: '425',
    img: img1,
    type: 'skin care',
},
{
    name: 'SKIN',
    detail: 'Super Skin Care',
    price: '930',
    img: img2,
    type: 'skin care',
},
{
    name: 'NATURE',
    detail: 'Super Skin Care',
    price: '525',
    img: img3,
    type: 'skin care',
},
{
    name: 'Foundation',
    detail: 'Super Skin Care',
    price: '825',
    img: img4,
    type: 'foundations',
},
{
    name: 'CONDITIONER',
    detail: 'Super Skin Care',
    price: '630',
    img: img5,
    type: 'conditioners',
},
{
    name: 'NATURE',
    detail: 'Super Skin Care',
    price: '425',
    img: img6,
    type: 'skin care',
},
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '830',
    img: img7,
    type: 'conditioners'
}
,
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '930',
    img: img8,
    type: 'conditioners'
},
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '630',
    img: img9,
    type: 'conditioners'
},
{
    name: "CONDITIONER",
    details: 'Best Conditioner',
    price: '730',
    img: img10,
    type: 'conditioners'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '512',
    img: img11,
    type: 'foundations'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '712',
    img: img12,
    type: 'foundations'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '612',
    img: img13,
    type: 'foundations'
},
{
    name: "FOUNDATION",
    details: 'Nourish your skin',
    price: '812',
    img: img14,
    type: 'foundations'
}

]